import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const OrderFilters = ({ 
  filters, 
  onFilterChange, 
  onClearFilters,
  onCreateOrder 
}) => {
  const statusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'cotizada', label: 'Cotizada' },
    { value: 'aprobada', label: 'Aprobada' },
    { value: 'en_proceso', label: 'En proceso' },
    { value: 'lista', label: 'Lista' },
    { value: 'entregada', label: 'Entregada' },
    { value: 'cancelada', label: 'Cancelada' }
  ];

  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            type="search"
            label="Buscar cliente"
            placeholder="Nombre o teléfono"
            value={filters?.search}
            onChange={(e) => handleInputChange('search', e?.target?.value)}
          />

          <Select
            label="Estado"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleInputChange('status', value)}
          />

          <Input
            type="date"
            label="Fecha desde"
            value={filters?.dateFrom}
            onChange={(e) => handleInputChange('dateFrom', e?.target?.value)}
          />

          <Input
            type="date"
            label="Fecha hasta"
            value={filters?.dateTo}
            onChange={(e) => handleInputChange('dateTo', e?.target?.value)}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Limpiar
          </Button>
          <Button
            variant="default"
            onClick={onCreateOrder}
            iconName="Plus"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Nueva Orden
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderFilters;